import $ from 'jquery';
import Reflux from 'reflux';
import MenuActions from './actions';
import Utils from 'medscape/utils';

export default class MobileMenuStore extends Reflux.Store {
    constructor(props) {
        super();
        let state = this.getInitialState();
        this.props = props;
        this.listenables = [MenuActions];
    }
    getInitialState() {
        return {
            isOpen: false
        }
    }
    onToggle(_state) {
        let newState = _state ? _state : !this.state.isOpen;
        this.setState({
            isOpen: newState
        });

    }
}



// WEBPACK FOOTER //
// ./src/app/mobile-menu/store.js